export default "__VITE_ASSET__ebA2J1OA__"